module.exports = __webpack_public_path__ + "static/media/rogue6.4e039cad.jpg";